export default __webpack_public_path__ + "static/media/Avond met hapjes en gezelligheid.59679dbe.jpg";